import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export const LOW_STOCK = 1;

export const LowStockAlert = ({ items, showLink }) => {
  if (!items?.length) return null;
  return (
    <div data-testid="low-stock-alert" className="border border-amber-500/40 bg-amber-500/10 p-4 flex gap-3">
      <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
      <div className="text-sm flex-1">
        <div className="font-display font-bold uppercase tracking-wider text-amber-400">
          Mažas likutis: {items.length} {items.length === 1 ? "sėdynė" : "sėdynės"} (≤ {LOW_STOCK} vnt.)
        </div>
        <ul className="mt-2 space-y-1 text-slate-300">
          {items.map((p) => (
            <li key={p.id} data-testid={`low-stock-item-${p.id}`}>
              {p.name} — <span className={`font-mono-x ${p.stock === 0 ? "text-red-400" : "text-amber-400"}`}>{p.stock === 0 ? "baigėsi" : `${p.stock} vnt.`}</span>
            </li>
          ))}
        </ul>
      </div>
      {showLink && <Link to="/admin/products" data-testid="low-stock-manage-link" className="text-sm text-orange-500 self-start whitespace-nowrap">Tvarkyti →</Link>}
    </div>
  );
};
